import { render, staticRenderFns } from "./classifySearch.vue?vue&type=template&id=4f212e7c&scoped=true"
import script from "./classifySearch.vue?vue&type=script&lang=js"
export * from "./classifySearch.vue?vue&type=script&lang=js"
import style0 from "./classifySearch.vue?vue&type=style&index=0&id=4f212e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f212e7c",
  null
  
)

export default component.exports